import { render, staticRenderFns } from "./addM.vue?vue&type=template&id=58293670"
import script from "./addM.vue?vue&type=script&lang=js"
export * from "./addM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports